// src/components/checagens/AtribuirResponsavelModal.tsx
import React, { useState } from 'react';
import { useUsers, User } from '../../hooks/useUsers';
import { useUpdateChecagemResponsavel } from '../../hooks/useChecagens';
import './AtribuirResponsavelModal.css';

interface AtribuirResponsavelModalProps {
  checagemId: number;
  onClose: () => void;
}

const AtribuirResponsavelModal: React.FC<AtribuirResponsavelModalProps> = ({ checagemId, onClose }) => {
  const { data: users, isLoading } = useUsers();
  const [selectedUserId, setSelectedUserId] = useState<number | null>(null);
  const mutation = useUpdateChecagemResponsavel();

  const handleAssign = () => {
    if (selectedUserId) {
      mutation.mutate({ id: checagemId, responsavel_usuario_id: selectedUserId }, {
        onSuccess: onClose,
      });
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Atribuir Responsável</h2>
        {isLoading ? (
          <p>Carregando usuários...</p>
        ) : (
          <div className="form-group">
            <label htmlFor="user-select">Usuário</label>
            <select 
              id="user-select"
              onChange={(e) => setSelectedUserId(Number(e.target.value))}
              value={selectedUserId || ''}
            >
              <option value="" disabled>Selecione um usuário</option>
              {users?.map((user: User) => (
                <option key={user.id} value={user.id}>{user.nome}</option>
              ))}
            </select>
          </div>
        )}
        <div className="modal-actions">
          <button onClick={onClose} className="btn-cancel">Cancelar</button>
          <button onClick={handleAssign} className="btn-confirm" disabled={!selectedUserId || mutation.isPending}>
            {mutation.isPending ? 'Atribuindo...' : 'Atribuir'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AtribuirResponsavelModal;
